
      import API from "!../../../../orca-ui/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../orca-ui/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../orca-ui/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../orca-ui/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../orca-ui/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../orca-ui/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../orca-ui/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./animations.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../orca-ui/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!./animations.css";
       export default content && content.locals ? content.locals : undefined;
